import PreviewVehicle from './PreviewVehicle';
export default PreviewVehicle;